
import { create } from "zustand";

export const globalStore = create((set) => ({
  landingPageData: [],
  productListingPageData: [],
  comboProductPageData: [],
  mostWantedProductPageData: [],
  newAdditonProductPageData: [],
  productDetailsPageData: [],
  cartPageData: [],
  addressPageData: [],
  couponData: [],
  category:[],
  customProductAttribute: { tShirtSize: null, fontColor: null },
  cartCount: 0,
  otpStatus: null,
  otpVerificationStatus: null,
  initiatePaymentStatus: null,
  profileData: null,
  updateProfileStatus: null,
  CustomerFilterData: null,
  getOrdersData: [],
  updateCartPageData: [],
  wishlistData: [],
  applyCouponData:[],
  applyWithCode:[],

  newsletterData:null,
  productDetailsData:[],
  wishlistShowData:[],
  productOverviewData: [],
  darkMode : false,
  pinCodeData : [],
  searchData:[],

  filterOption:[],


  setLandingPageData: (value) => set({ landingPageData: value }),
  setCouponData: (value) => set({ couponData: value }),
  setProductListingPageData: (value) => set({ productListingPageData: value }),
  setComboProductPageData: (value) => set({ comboProductPageData: value }),
  setMostWantedProductPageData: (value) => set({ mostWantedProductPageData: value }),
  SetnewAdditonProductPageData: (value) => set({ newAdditonProductPageData: value }),
  setProductDetailsPageData: (value) => set({ productDetailsPageData: value }),
  setCartPageData: (value) => set({ cartPageData: value }),
  setAddressPageData: (value) => set({ addressPageData: value }),
  setCustomProductAttribute: (value) => set({ customProductAttribute: value }),
  setCartCount: (value) => set({ cartCount: value }),
  setOtpStatus: (value) => set({ otpStatus: value }),
  setOtpVerificationStatus: (value) => set({ otpVerificationStatus: value }),
  setInitiatePaymentStatus: (value) => set({ initiatePaymentStatus: value }),
  setProfileData: (value) => set({ profileData: value }),
  setUpdateProfileStatus: (value) => set({ updateProfileStatus: value }),
  setCustomerFilterData: (value) => set({ CustomerFilterData: value }),
  setGetOrdersData: (value) => set({ getOrdersData: value }),
  setUpdateCartPageData: (value) => set({ updateCartPageData: value }), 
  setWishlistData: (value) => set({ wishlistData: value }),
  setApplyCouponData: (value) => set({ applyCouponData: value }),
  setApplyCouponDataWithCode: (value) => set({ applyWithCode: value }),

  setNewsletterData: (value) => set({ newsletterData: value }),
  setProductDetailsData: (value) => set({ productDetailsData: value }),
  setWishlistShowData: (value) => set({ wishlistShowData: value }),
  setDarkMode: (value) => set({ darkMode: value }),
  setPinCodeData: (value) => set({ pinCodeData: value }),
  setProductOverviewData: (value) => set({ productOverviewData: value }),
  setSearchData: (value) => set({ searchData: value }),
  setCategory : (value) => set({category:value}),


  setFilterOption: (value) => set({ filterOption: value }),

}));
